export abstract class DialogIdentifier {
  static AboutView = 'about_view';
  static CertView = 'cert_view';
  static UserProfileView = 'user_profile_view';
  static UploadView = 'upload_view';
}



// WEBPACK FOOTER //
// ./src/app/services/dialog-identifier.ts